module.exports = __webpack_public_path__ + "static/pam-2ff07f1ab76b4098deec48e64a3fbf3f.jpg";